import {Button, Checkbox, FormControlLabel, Grid, TextField, Theme, Typography} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import {makeStyles} from '@material-ui/styles';
import React, {useState} from 'react';
import {LoadingOverlay} from '../../../components/LoadingOverlay';
import anyLoading from '../../../utils/anyLoading';
import {initialFilters} from './RoomPartyList';
import {formatGraphQlDate} from '../../../utils/formatters';

const useStyles = makeStyles((theme: Theme) => ({
    root: {},
    content: {
        padding: theme.spacing(0, 3),
        flexGrow: 1
    },
    contentSection: {
        padding: theme.spacing(2, 0)
    },
    contentSectionHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        cursor: 'pointer'
    },
    contentSectionContent: {},
    formGroup: {
        padding: theme.spacing(2, 0)
    },
    fieldGroup: {
        display: 'flex',
        alignItems: 'center'
    },
    field: {
        marginTop: 0,
        marginBottom: 0
    },
    flexGrow: {
        flexGrow: 1
    },
    addButton: {
        marginLeft: theme.spacing(1)
    },
    tags: {
        marginTop: theme.spacing(1)
    },
    radioGroup: {},
    buttonIcon: {
        marginRight: theme.spacing(1)
    },
    actions: {
        padding: theme.spacing(3),
        '& > * + *': {
            marginTop: theme.spacing(2)
        }
    }
}));

export interface FilterValues {
    id?: number,
    start_date: Date | string
    end_date: Date | string
    notes: string,
    wheelchair_accessTrue: boolean,
    wheelchair_accessFalse: boolean,
    has_infantsTrue: boolean,
    has_infantsFalse: boolean,
    disabledTrue: boolean,
    disabledFalse: boolean,
    members_different_datesTrue: boolean,
    members_different_datesFalse: boolean,
}

export const SearchFilter = (props: { applyFilters: (filters: FilterValues) => void, filters: FilterValues, initialFilters: FilterValues }) => {
  const {filters } = props;
  const classes = useStyles();
  const [values, setValues] = useState({ ...filters });

  const loadingData = anyLoading();

    const handleClear = () => {
      props.applyFilters(initialFilters);
    };

    const handleFieldChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
      event.persist();

      setValues(oldValues => ({
        ...oldValues,
        [event.target.name]: event.target.type === 'checkbox' ? (event.target as HTMLInputElement).checked : event.target.value
      }));
    };

    const applyFilters = () => {
      props.applyFilters(values);
    };
    return (
        <React.Fragment>
            <LoadingOverlay loading={loadingData.loading}>
                <div className={classes.content}>
                    <div className={classes.contentSection}>

                        <div className={classes.formGroup}>
                            <Typography component="p" gutterBottom variant="overline">
                                Date Range
                            </Typography>
                            <Grid container spacing={3}>
                                <Grid item md={6}>
                                    <TextField
                                        className={classes.field}
                                        defaultValue={values.start_date ? formatGraphQlDate(values.start_date) : ''}
                                        fullWidth
                                        label="Start date"
                                        name="start_date"
                                        onChange={handleFieldChange}
                                        type="date"
                                        InputLabelProps={{shrink: true}}
                                        variant="outlined"
                                    />
                                </Grid>
                                <Grid item md={6}>
                                    <TextField
                                        className={classes.field}
                                        defaultValue={values.end_date ? formatGraphQlDate(values.end_date) : ''}
                                        fullWidth
                                        label="End date"
                                        name="end_date"
                                        onChange={handleFieldChange}
                                        type="date"
                                        InputLabelProps={{shrink: true}}
                                        variant="outlined"
                                    />
                                </Grid>
                            </Grid>
                        </div>

                        <div className={classes.formGroup}>
                            <div className={classes.fieldGroup}>
                                <TextField className={classes.field}
                                           fullWidth
                                           label="Notes"
                                           name="notes"
                                           onChange={handleFieldChange}
                                           value={values.notes}
                                           variant="outlined"
                                />
                            </div>
                        </div>

                        <div className={classes.formGroup}>
                            <Typography component="span" gutterBottom variant="overline" style={{paddingRight: 10}}>Wheelchair
                                Access?</Typography>
                            <FormControlLabel
                                label="yes"
                                control={<Checkbox checked={values.wheelchair_accessTrue} onChange={handleFieldChange}
                                                   name="wheelchair_accessTrue"/>}
                            />
                            <FormControlLabel
                                label="no"
                                control={<Checkbox checked={values.wheelchair_accessFalse} onChange={handleFieldChange}
                                                   name="wheelchair_accessFalse"/>}
                            />
                        </div>


                    <div className={classes.formGroup}>
                      <Typography component="span" gutterBottom variant="overline" style={{paddingRight: 10}}>Has infants?</Typography>
                        <FormControlLabel
                            label="yes"
                            control={<Checkbox checked={values.has_infantsTrue} onChange={handleFieldChange}
                                               name="has_infantsTrue"/>}
                        />
                        <FormControlLabel
                            label="no"
                            control={<Checkbox checked={values.has_infantsFalse} onChange={handleFieldChange}
                                               name="has_infantsFalse"/>}
                        />
                    </div>

                        <div className={classes.formGroup}>
                            <Typography component="span" gutterBottom variant="overline"
                                        style={{paddingRight: 10}}>Disabled?</Typography>
                            <FormControlLabel
                                label="yes"
                                control={<Checkbox checked={values.disabledTrue} onChange={handleFieldChange}
                                                   name="disabledTrue"/>}
                            />
                            <FormControlLabel
                                label="no"
                                control={<Checkbox checked={values.disabledFalse} onChange={handleFieldChange}
                                                   name="disabledFalse"/>}
                            />
                        </div>

                        <div className={classes.formGroup}>
                            <Typography component="span" gutterBottom variant="overline"
                                        style={{paddingRight: 10}}>Varied Stay Length Guests?</Typography>
                            <FormControlLabel
                                label="yes"
                                control={<Checkbox checked={values.members_different_datesTrue}
                                                   onChange={handleFieldChange}
                                                   name="members_different_datesTrue"/>}
                            />
                            <FormControlLabel
                                label="no"
                                control={<Checkbox checked={values.members_different_datesFalse}
                                                   onChange={handleFieldChange}
                                                   name="members_different_datesFalse"/>}
                            />
                        </div>
                    </div>
                </div>
                <div className={classes.actions}>
                    <Button id="clear" fullWidth onClick={handleClear} variant="contained">
                        <DeleteIcon className={classes.buttonIcon}/>
                        Clear
                    </Button>
                    <Button id="submit" color="primary" fullWidth variant="contained" onClick={applyFilters}>
                        Apply filters
                    </Button>
                </div>
            </LoadingOverlay>
        </React.Fragment>
    );
};

export default SearchFilter;
